import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  batchId: z.string().optional(),
  batchName: z.string().optional()
})

export const SARListRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `/`,
    component: lazyRouteComponent(() => import('./List')),
    validateSearch: (search) => searchSchema.parse(search)
  })
